import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const FormIcon = createSvgIcon(
  <>
    <path
      d="M5.66667 3.33325H3.33333C2.71449 3.33325 2.121 3.57908 1.68342 4.01667C1.24583 4.45425 1 5.04775 1 5.66659V19.6666C1 20.2854 1.24583 20.8789 1.68342 21.3165C2.121 21.7541 2.71449 21.9999 3.33333 21.9999H15C15.6188 21.9999 16.2123 21.7541 16.6499 21.3165C17.0875 20.8789 17.3333 20.2854 17.3333 19.6666V5.66659C17.3333 5.04775 17.0875 4.45425 16.6499 4.01667C16.2123 3.57908 15.6188 3.33325 15 3.33325H12.6667"
      {...strokeProps}
    />
    <path
      d="M5.6665 3.33333C5.6665 2.71449 5.91234 2.121 6.34992 1.68342C6.78751 1.24583 7.381 1 7.99984 1H10.3332C10.952 1 11.5455 1.24583 11.9831 1.68342C12.4207 2.121 12.6665 2.71449 12.6665 3.33333C12.6665 3.95217 12.4207 4.54566 11.9831 4.98325C11.5455 5.42083 10.952 5.66667 10.3332 5.66667H7.99984C7.381 5.66667 6.78751 5.42083 6.34992 4.98325C5.91234 4.54566 5.6665 3.95217 5.6665 3.33333Z"
      {...strokeProps}
    />
    <path d="M5.6665 11.5H5.67762" {...strokeProps} />
    <path d="M10.3333 11.5H12.6666" {...strokeProps} />
    <path d="M5.6665 16.1666H5.67762" {...strokeProps} />
    <path d="M10.3333 16.1666H12.6666" {...strokeProps} />
  </>,
  { displayName: 'FormIcon', viewBox: '0 0 19 23' }
);
